import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederNordenDto from '../Models/VeilederNordenDto';
import { VeilederNordenAppState } from '../Store';
import { connect } from 'react-redux';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { StamdataNordenHelgradModel } from '../Models/StamdataNordenHelgradModel';
import * as ValgTypes from '../Store/Valg/Types';
import UtbetalingDetaljerComponent from './UtbetalingDetaljerComponent'
import { formatNumber } from '../Utilities/Helpers';
import { ResultatValgVisning } from '../Store/Resultat/Types';
import VarighetTypeValg from '../Utilities/VarighetTypeValg';

interface UtbetalingOwnProps {
    satser: StamdataNordenHelgradModel | null,
    valg: ValgTypes.ValgState,
    resultat: ResultatValgVisning,
    locale: string,
    valuta: string,
}

type UtbetalingProps = UtbetalingOwnProps & MapStateToProps & {};

const UtbetalingComponent = (props: UtbetalingProps): JSX.Element => {
    const { epiContext } = props;

    let utbetalingsDetaljer: JSX.Element | null = null;
    if(props.resultat.visBetPlan) {
        utbetalingsDetaljer = <UtbetalingDetaljerComponent valg={props.valg} satser={props.satser} locale={props.locale} valuta={props.valuta} />
    }
    
    function hentUtbetalingJuni(): number {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG !== undefined)
            return props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * 30

        return 0;
    }

    function hentHovedUtbetaling(): number {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG === undefined)
            return 0;

        let skolepenger:number = 0;
        if(props.valg.cSkolepengerBelop !== undefined)
            skolepenger = props.valg.cSkolepengerBelop;

        if(props.valg.aVarighet?.value === VarighetTypeValg.a1_hele) {
            return (props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * 150) + (skolepenger / 2);
            
        } else {
            return (props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * 150) + skolepenger;
        }
    }

    return (

        <div className="c-veileder__panel c-veileder__panel--info c-veileder__panel--white-aubergine">
            <div className="c-veileder__panel-row">

                {(props.valg.aVarighet?.value === VarighetTypeValg.a1_hele || props.valg.aVarighet?.value === VarighetTypeValg.a2_host) && (
                    <div className="c-veileder__content">
                        <h4 className="c-veileder__tittel c-veileder__tittel--info">
                            {contentResolver(epiContext, 'betPlanKolonneTittelHost')}
                        </h4>
                        <div role="table" className="c-table">
                            <div role="row" className="c-table__header-row">
                                <div role="columnheader" className="c-table__header-cell">
                                    {contentResolver(epiContext, 'betPlanKolonneTittelDato')}
                                </div>
                                <div role="columnheader" className="c-table__header-cell">
                                    {contentResolver(epiContext, 'betPlanKolonneTittelBelop')}
                                </div>
                            </div>
                            <div role="row" className="c-table__data-row">
                                <div role="cell" className="c-table__data-cell">
                                    {contentResolver(epiContext, 'betPlanMndJuli')}
                                </div>
                                <div role="cell" className="c-table__data-cell">
                                    {formatNumber(Math.round(hentHovedUtbetaling()), props.locale)}
                                    &nbsp;{props.valuta}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {(props.valg.aVarighet?.value === VarighetTypeValg.a1_hele || props.valg.aVarighet?.value === VarighetTypeValg.a3_vaar) && (
                    <div className="c-veileder__content">
                        <h4 className="c-veileder__tittel c-veileder__tittel--info">
                            {contentResolver(epiContext, 'betPlanKolonneTittelVar')}
                        </h4>
                        <div role="table" className="c-table">
                            <div role="row" className="c-table__header-row">
                                <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                                    {contentResolver(epiContext, 'betPlanKolonneTittelDato')}
                                </div>
                                <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                                    {contentResolver(epiContext, 'betPlanKolonneTittelBelop')}
                                </div>
                            </div>
                            <div role="row" className="c-table__data-row">
                                <div role="cell" className="c-table__data-cell">
                                    {contentResolver(epiContext, 'betPlanMndDesember')}
                                </div>
                                <div role="cell" className="c-table__data-cell">
                                {formatNumber(Math.round(hentHovedUtbetaling() - 0.1), props.locale)}
                                    &nbsp;{props.valuta}
                                </div>
                            </div>
                            <div role="row" className="c-table__data-row">
                                <div role="cell" className="c-table__data-cell">
                                    {contentResolver(epiContext, 'betPlanMndJuli')}
                                </div>
                                <div role="cell" className="c-table__data-cell">
                                    {formatNumber(Math.round(hentUtbetalingJuni()), props.locale)}
                                    &nbsp;{props.valuta}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h4 className="c-veileder__tittel c-veileder__tittel--info">
                        {contentResolver(epiContext, 'betPlanTittelVenstreSpalte')}
                    </h4>
                    {contentResolver(epiContext, 'betPlanVenstreSpalte')}
                </div>
                <div className="c-veileder__content">
                    <h4 className="c-veileder__tittel c-veileder__tittel--info">
                        {contentResolver(epiContext, 'betPlanTittelHoyreSpalte')}
                    </h4>
                    {contentResolver(epiContext, 'betPlanHoyreSpalte')}
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content--horizontal-center">
                    <div className="c-veileder__content ">
                        <div className="c-infoboks--egg-sunshine">
                            {utbetalingsDetaljer}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederNordenDto>;
}

export default connect(
    (state: VeilederNordenAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(UtbetalingComponent);
